
import { MoonStar, type LucideProps } from "lucide-react"

export const Logo = (props: LucideProps) => (
  <MoonStar {...props} />
)
